import React from 'react';
import { HtmlAnchor } from '@helpcenter/analytics-components/src/html-anchor';
import { initializeConnect } from '@helpcenter/connect-fragment';

import { CustomItem, Section } from '@atlaskit/menu';
import { withDeferredWrmLoaded } from '@atlassian/help-center-common-util/wrm';

import type { CustomMenuLinkModel } from '../../../state/persisted/user/reducer';

interface ConnectMenuLinksProps {
	customMenuLinks: CustomMenuLinkModel[];
	onClose: () => void;
}

interface HubConnectMenuSectionProps {
	customMenuLinks: CustomMenuLinkModel[];
}

const ConnectMenuLinks = ({ customMenuLinks, onClose }: ConnectMenuLinksProps) => (
	<span data-test-id="custom-menu-link">
		{customMenuLinks.map((menuLink) => {
			const menuLinkKey = menuLink.id || menuLink.key || menuLink.href;

			return (
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Connect apps provide AP classes for dialog behaviour.
				<div key={`hub-custom-menu-link_${menuLinkKey}`} className={menuLink.styleClass}>
					<CustomItem
						actionSubjectId="custom-menu-link"
						component={HtmlAnchor}
						href={menuLink.href}
						onClick={onClose}
						data-test-id="custom-menu-link"
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
						className="cv-exclude-from-customisation"
					>
						{menuLink.label}
					</CustomItem>
				</div>
			);
		})}
	</span>
);

const DeferredConnectMenuLinks = withDeferredWrmLoaded(ConnectMenuLinks, initializeConnect);

export const HubConnectMenuSection = ({ customMenuLinks }: HubConnectMenuSectionProps) => {
	if (customMenuLinks.length === 0) {
		return null;
	}

	return (
		<Section hasSeparator>
			<DeferredConnectMenuLinks customMenuLinks={customMenuLinks} onClose={() => undefined} />
		</Section>
	);
};
